<template>
    <div class="trained-machine-container advanced-section">
        <h2 class="step-title">Machine entrainée</h2>
        <el-form-item label=" " class="training-type">
            <el-switch
                v-model="form.type"
                active-value="other"
                inactive-value="power"
                inactive-text="Puissance"
                active-text="Pression, Débit, Rendement"
            >
            </el-switch>
        </el-form-item>
        <div
            v-if="form.type === 'other'"
        >
            <div class="unit-container">
                <el-form-item class="input" label="Pression" prop="trained_machine.pressure" :show-message="showMessage('pressure')">
                    <el-input type="number" v-model="form.pressure"></el-input>
                </el-form-item>
                <el-form-item class="unit" label="Unité de pression" prop="trained_machine.pressure_unit" :show-message="showMessage('pressure_unit')">
    
                    <el-select name="carcasse" id="carcasse" v-model="form.pressure_unit" placeholder="Sélectionner une unité" required>
                        <el-option
                            v-for="opt in ['bar', 'Pa', 'mCe']"
                            :key="opt"
                            :value="opt"
                        >
                            {{opt}}
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
            <div class="unit-container">
                <el-form-item label="Débit" class="input" prop="trained_machine.flow" :show-message="showMessage('flow')">
                    <el-input type="number" v-model="form.flow"></el-input>
                </el-form-item>
                <el-form-item label="Unité de débit" class="unit" prop="trained_machine.flow_unit" :show-message="showMessage('flow_unit')">
                    <el-select name="carcasse" id="carcasse" v-model="form.flow_unit" placeholder="Sélectionner une unité" required>
                        <el-option
                            v-for="opt in ['m³/s', 'm³/min', 'm³/h']"
                            :key="opt"
                            :value="opt"
                        >
                            {{opt}}
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
            <el-form-item label="Rendement" class="input" prop="trained_machine.efficiency" :show-message="showMessage('efficiency')">
                <el-tooltip class="formTooltip" effect="dark" placement="right" content="Doit être compris entre 0 et 1">
                    <el-input type="number" v-model="form.efficiency"></el-input>
                </el-tooltip>
            </el-form-item>
            <TrainedMachinePowerValue
                :motor="motor"
                :trainedMachine="form"
            ></TrainedMachinePowerValue>
        </div>
        <div
            v-else
        >
            <el-form-item label="Puissance (kW)" prop="trained_machine.pn_me" :show-message="showMessage('pn_me')">
                <el-input type="number" v-model="form.pn_me"></el-input>
            </el-form-item>
        </div>
    </div>
</template>

<script>
    import TrainedMachinePowerValue from './TrainedMachinePowerValue.vue'
    export default {
        name:'TrainedMachineForm',
        components:{
            TrainedMachinePowerValue
        },
        props:{
            form:{
                type: Object,
                required: true,
            },
            motor:{
                type: Object,
                required: true,
            }
        },methods:{
            showMessage(el) {
                if (this.form[el].length)
                    return true;
                return false;
            },
        }
    }
</script>

<style lang="scss" scoped>
.trained-machine-container {
    padding: 5px 15px 40px;
    border: 5px solid #efefef !important;
    .training-type{
        text-align: center;
    }
    .unit-container{
        display: flex;
        justify-content: space-between;
        gap: 2rem;
        .el-select{
            width: 100%;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/partials/wizard/TrainedMachineForm.vue